import { IOrganisation, IOrganisationForm, ISaveOrganisation } from '../../shared';

export const organisationToFormMapper = (organisation: IOrganisation): IOrganisationForm => {
    return {
        ...organisation,
        type: organisation.type.id || '',
        supportTypes: organisation.supportTypes.map(({ id }) => id),
        defaultSupportTypeId: organisation.defaultSupportTypeId || '',
    };
};

export const organisationFromFormMapper = (organisation: IOrganisationForm): ISaveOrganisation => {
    return {
        ...organisation,
        supportTypes:
            !organisation.defaultSupportTypeId || organisation.supportTypes.includes(organisation.defaultSupportTypeId)
                ? organisation.supportTypes
                : [...organisation.supportTypes, organisation.defaultSupportTypeId],
        defaultSupportTypeId:
            organisation.defaultSupportTypeId ||
            (organisation.supportTypes.length ? organisation.supportTypes[0] : null),
    };
};
